'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useMemo } from 'react';
import { styled } from '@classify/react-core-components/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Box from '@classify/react-core-components/Box';
import CourseChapterHeader from '../../../[chapterSlug]/_components/CourseChapterHeader';
import TocToggler from '../../../[chapterSlug]/_components/TocToggler';
import CourseEditionPanel from '../../../[chapterSlug]/_components/CourseEditionPanel';
import EditionPanelVariants from '../../../[chapterSlug]/_constants/EditionPanelVariants';
import { useChapterContext } from '../../../[chapterSlug]/_contexts/ChapterContext';
import useTocState from '../../../_hooks/useTocState';
import { useExerciseContext } from '../_contexts/ExerciseContext';
import ExerciseContentWrapper from './ExerciseContentWrapper';
import CourseFooterWrapper from './CourseFooterWrapper';
const ExercisePageContentWrapper = styled(ContentWrapper)(({
  theme: {
    spacing
  }
}) => ({
  padding: spacing(4, 2),
  width: 'fill-available'
}));
interface Props {
  isTocInitiallyOpen: boolean;
}
export default function Page(t0) {
  const $ = _c(20);
  const {
    isTocInitiallyOpen
  } = t0;
  const {
    course
  } = useChapterContext();
  const {
    exerciseId,
    canEditCourse
  } = useExerciseContext();
  const headerRef = useRef(null);
  const [isTocOpen, setIsTocOpen] = useTocState(isTocInitiallyOpen);
  let t1;
  if ($[0] !== isTocOpen || $[1] !== setIsTocOpen) {
    t1 = <TocToggler headerRef={headerRef} isOpen={isTocOpen} setIsOpen={setIsTocOpen} />;
    $[0] = isTocOpen;
    $[1] = setIsTocOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const memoizedToc = t1;
  if (!course) {
    return null;
  }
  let t2;
  if ($[3] !== course.categoryColor) {
    t2 = {
      "--categoryColor": course.categoryColor
    };
    $[3] = course.categoryColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = t2 as React.CSSProperties;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CourseChapterHeader headerRef={headerRef} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      position: "relative",
      pb: 2
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== canEditCourse || $[8] !== exerciseId) {
    t6 = canEditCourse && <CourseEditionPanel exerciseId={`${exerciseId}`} variant={EditionPanelVariants.QUIZ} />;
    $[7] = canEditCourse;
    $[8] = exerciseId;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ExerciseContentWrapper />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <ExercisePageContentWrapper variant="narrow">{t6}{t7}</ExercisePageContentWrapper>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== memoizedToc || $[14] !== t8) {
    t9 = <Box sx={t5}>{memoizedToc}{t8}</Box>;
    $[13] = memoizedToc;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CourseFooterWrapper />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t3 || $[18] !== t9) {
    t11 = <div style={t3}>{t4}{t9}{t10}</div>;
    $[17] = t3;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}